"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styled_components_1 = require("styled-components");
var StyledIcon = styled_components_1.default.i(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    color:", "\n"], ["\n    color:", "\n"])), function (p) { return p.color; });
var CheckBoxBuilder = function (props) {
    var color = props.checked ? "#5cb85c" : "#d9534f";
    return (React.createElement("p", null,
        React.createElement(StyledIcon, { color: color, className: props.checked ? "fa fa-check" : "fa fa-close" },
            "\u00A0  ",
            props.intl.formatMessage({ id: props.label }))));
};
exports.default = (CheckBoxBuilder);
var templateObject_1;
//# sourceMappingURL=CheckBoxBuilder.js.map